export const formatCurrency = (value: number): string => {
  if (value >= 1e9) return `CHF ${(value / 1e9).toFixed(1)}B`
  if (value >= 1e6) return `CHF ${(value / 1e6).toFixed(1)}M`
  if (value >= 1e3) return `CHF ${(value / 1e3).toFixed(0)}K`
  return `CHF ${value.toFixed(0)}`
}

export const formatChange = (value: number): string => {
  const sign = value >= 0 ? '+' : ''
  return `${sign}${value.toFixed(1)}%`
}
